export const categorias = [
    {
        name: "Mochilas",
        id: 1,
    },
    {
        name: "Riñoneras",
        id: 2,
    },
    {
        name: "Gorras",
        id: 3,
    },
];

export const Productos = [
    {
        id: 11,
        name: "Mochila Unicross Portanotebook Negra",
        category: 1,
        img: "https://d2r9epyceweg5n.cloudfront.net/stores/001/182/684/products/62-3656-11-7a03390612249f99ab16702503793477-320-0.jpg",
    },
    {
        id: 12,
        name: "Mochila Unicross Portanotebook Gris",
        category: 1,
        img: "https://d2r9epyceweg5n.cloudfront.net/stores/001/182/684/products/62-3655-21-975dea6e192edafaae16702503782006-320-0.jpg",
    },
    {
        id: 13,
        name: "Mochila Unicross Portanotebook Azul",
        category: 1,
        img: "https://d2r9epyceweg5n.cloudfront.net/stores/001/182/684/products/62-3613-21-c959f5aff0cc6adcf816702503722856-320-0.jpg",
    },
    {
        id: 14,
        name: "Riñonera Head",
        category: 2,
        img: "https://d2r9epyceweg5n.cloudfront.net/stores/001/182/684/products/270181-4738c0d82057d5890616603166668182-320-0.jpg",
    },
    {
        id: 15,
        name: "Riñonera Everlast",
        category: 2,
        img: "https://d2r9epyceweg5n.cloudfront.net/stores/001/182/684/products/14343i11-813247230f892afa6a16594620988935-320-0.jpg",
    },
    {
        id: 16,
        name: "Gorra Everlast",
        category: 3,
        img: "https://d2r9epyceweg5n.cloudfront.net/stores/001/182/684/products/14333-11-c4128b8ec7395fd0cc16612781040764-320-0.jpg",
    },
];

export const menus = [
    {
        name: "Inicio",
        href: "/",
    },
];
